/** Belge yükleyebilmek için gereken en küçük yaş (bkz. Kullanım Şartları). */
export const MIN_UPLOAD_AGE = 18;
/**
 * Tam doğum tarihinden yaş. Yalnızca tarayıcıda kullanılır: belgedeki tam doğum tarihi
 * hiçbir zaman sunucuya gönderilmez, orada sadece doğum yılı bulunur.
 */
export function ageFromBirthDate(day, month, year, now = new Date()) {
    const age = now.getFullYear() - year;
    const month1 = now.getMonth() + 1;
    const dogumGunuGelmedi = month1 < month || (month1 === month && now.getDate() < day);
    return dogumGunuGelmedi ? age - 1 : age;
}
/**
 * Doğum yılından ulaşılabilecek EN BÜYÜK yaş.
 *
 * Sunucuya yalnızca doğum yılı geldiği için sınır kontrolü bununla yapılır: bu değer
 * sınırın altındaysa kullanıcı doğum gününe bakılmaksızın kesinlikle küçüktür. Böylece
 * reşit bir kullanıcı yıl bilgisi yüzünden yanlışlıkla engellenmez; tam kontrolü tam
 * tarihe sahip olan tarayıcı yapar.
 */
export function maxAgeInYear(birthYear, now = new Date()) {
    return now.getFullYear() - birthYear;
}
//# sourceMappingURL=age.js.map